export type SessionArchetype = 'destreza' | 'indagacion' | 'taller' | 'evaluacion';

export type DestrezaVariant = 'guiado' | 'autonomo';

export interface SessionConfig {
  archetype: SessionArchetype;
  /** Solo aplica si archetype === 'destreza' */
  variant?: DestrezaVariant;
}

export interface SessionArchetypeMeta {
  id: SessionArchetype;
  label: string;
  description: string;
}

export const SESSION_ARCHETYPE_OPTIONS: SessionArchetypeMeta[] = [
  {
    id: 'destreza',
    label: 'Destreza',
    description: 'Automatizar un procedimiento o habilidad con práctica deliberada.',
  },
  {
    id: 'indagacion',
    label: 'Indagación',
    description: 'Explorar, preguntar y construir explicaciones a partir de evidencia.',
  },
  {
    id: 'taller',
    label: 'Proyecto / Taller',
    description: 'Crear un producto o resolver un desafío con fases de trabajo.',
  },
  {
    id: 'evaluacion',
    label: 'Evaluación',
    description: 'Verificar avance con instrumento formativo alineado al hito.',
  },
];

export const DESTREZA_VARIANT_OPTIONS: Array<{ id: DestrezaVariant; label: string; description: string }> = [
  {
    id: 'guiado',
    label: 'Con modelado',
    description: 'Práctica guiada paso a paso tras modelado docente.',
  },
  {
    id: 'autonomo',
    label: 'Práctica autónoma',
    description: 'Ensayo o resolución independiente con monitoreo docente.',
  },
];

export function defaultSessionConfig(archetype: SessionArchetype = 'destreza'): SessionConfig {
  if (archetype === 'destreza') {
    return { archetype, variant: 'guiado' };
  }
  return { archetype };
}

export function normalizeSessionConfig(raw: unknown): SessionConfig | null {
  if (!raw || typeof raw !== 'object') return null;
  const record = raw as Record<string, unknown>;
  const archetype = String(record.archetype || '').trim();
  if (!SESSION_ARCHETYPE_OPTIONS.some((option) => option.id === archetype)) return null;

  const config: SessionConfig = { archetype: archetype as SessionArchetype };
  if (archetype === 'destreza') {
    config.variant = record.variant === 'autonomo' ? 'autonomo' : 'guiado';
  }
  return config;
}
